import axios from 'axios';

export default class FotwService {
    search(params={}) {
        return axios.post(`/api/fotw/search`, params);
    }
}



// WEBPACK FOOTER //
// ./resources/site/js/providers/api/fotw-service.js